import _import from '@/utils/import'
const Layout = _import('layout/Layout')

export const asyncRouterMap = [
  //设备管理
  {
    path: '/deviceManagement',
    component: Layout,
    redirect: 'noredirect',
    name: 'deviceManagement',
    meta: {
      title: '设备管理',
      icon: 'deviceManagement'
    },
    children: [
      {
        path: 'deviceOverview',
        component: _import('deviceManagement/deviceOverview'),
        name: 'deviceOverview',
        meta: { title: '设备列表' }
      },
      {
        path: 'waterPurifierDetail',
        component: _import('deviceManagement/waterPurifierDetail'),
        name: 'waterPurifierDetail',
        meta: { title: '净水器详情', hidden: true }
      },
      {
        path: 'deviceType',
        component: _import('deviceManagement/deviceType'),
        name: 'deviceType',
        meta: { title: '设备类型' }
      },
      {
        path: 'placement',
        component: _import('deviceManagement/placement'),
        name: 'placement',
        meta: { title: '投放管理' }
      },
      {
        path: 'installation',
        component: _import('deviceManagement/installation'),
        name: 'installation',
        meta: { title: '安装记录' }
      },
      {
        path: 'filterAlarm',
        component: _import('deviceManagement/filterAlarm'),
        name: 'filterAlarm',
        meta: { title: '滤芯告警' }
      },
      {
        path: 'longTimeNoUseAlarm',
        component: _import('deviceManagement/longTimeNoUseAlarm'),
        name: 'longTimeNoUseAlarm',
        meta: { title: '久放告警' }
      },
      {
        path: 'waterFilter',
        component: _import('deviceManagement/waterFilter'),
        name: 'waterFilter',
        meta: { title: '滤芯管理' }
      },
      {
        path: 'soymilkMakerDetail',
        component: _import('deviceManagement/soymilkMakerDetail'),
        name: 'soymilkMakerDetail',
        meta: { title: '豆浆机详情', hidden: true }
      },
      {
        path: 'timesMng',
        component: _import('deviceManagement/timesMng/index'),
        name: 'timesMng',
        meta: { title: '次数管理' }
      },
      {
        path: 'jobStatistics',
        component: _import('deviceManagement/jobStatistics'),
        name: 'jobStatistics',
        meta: { title: '作业统计' }
      }, {
        path: 'idleAlarm',
        component: _import('deviceManagement/idleAlarm'),
        name: 'idleAlarm',
        meta: { title: '闲置告警' }
      }
    ]
  },
  // 维保管理
  {
    path: '/maintainManagement',
    component: Layout,
    redirect: 'noredirect',
    name: 'maintainManagement',
    meta: {
      title: '维保管理',
      icon: 'maintainManagement'
    },
    children: [
      {
        path: 'ticketMng',
        component: _import('maintainManagement/ticketMng'),
        name: 'ticketMng',
        meta: { title: '工单管理' }
      },
      {
        path: 'feedbackMng',
        component: _import('maintainManagement/feedbackMng'),
        name: 'feedbackMng',
        meta: { title: '反馈管理' }
      }
    ]
  },
  //代理商管理
  {
    path: '/agentManagement',
    component: Layout,
    redirect: 'noredirect',
    name: 'agentManagement',
    meta: {
      title: '代理商管理',
      icon: 'agentManagement'
    },
    children: [
      {
        path: 'agentType',
        component: _import('agentManagement/agentType'),
        name: 'agentType',
        meta: { title: '代理商管理' }
      },
      {
        path: 'agentTypeSet',
        component: _import('agentManagement/agentTypeSet'),
        name: 'agentTypeSet',
        meta: { title: '代理商类型' }
      },
      {
        path: 'agentRecharge',
        component: _import('agentManagement/agentRecharge'),
        name: 'agentRecharge',
        meta: { title: '代理商充值' }
      },
      {
        path: 'salesTeam',
        component: _import('agentManagement/salesTeam'),
        name: 'salesTeam',
        meta: { title: '团队管理' }
      },
      {
        path: 'invitedAgent',
        component: _import('agentManagement/invitedAgent'),
        name: 'invitedAgent',
        meta: { title: '受邀代理商' }
      },
    ]
  },
  //运营商管理
  {
    path: '/operatorManagement',
    component: Layout,
    redirect: 'noredirect',
    name: 'operatorManagement',
    meta: {
      title: '运营商管理',
      icon: 'operatorManagement'
    },
    children: [
      {
        path: 'operatorType',
        component: _import('operatorManagement/operatorType'),
        name: 'operatorType',
        meta: { title: '运营商管理' }
      },
      {
        path: 'operatorTypeSet',
        component: _import('operatorManagement/operatorTypeSet'),
        name: 'operatorTypeSet',
        meta: { title: '运营商类型' }
      },
      {
        path: 'operatorRecharge',
        component: _import('operatorManagement/operatorRecharge'),
        name: 'operatorRecharge',
        meta: { title: '运营商充值' }
      }
    ]
  },
  //开单管理
  {
    path: '/accountManager',
    component: Layout,
    redirect: 'noredirect',
    name: 'accountManager',
    meta: {
      title: '开单管理',
      icon: 'userManagement'
    },
    children: [
      {
        path: 'accountRecord',
        component: _import('accountManager/accountRecord'),
        name: 'accountRecord',
        meta: { title: '开单记录' }
      },
      {
        path: 'returnRecord',
        component: _import('accountManager/returnRecord'),
        name: 'returnRecord',
        meta: { title: '退单记录' }
      },
      {
        path: 'buyOut',
        component: _import('accountManager/buyOut'),
        name: 'buyOut',
        meta: { title: '买断记录' }
      }
    ]
  },
  //用户管理
  {
    path: '/',
    component: Layout,
    name: 'userManagement1',
    children: [
      {
        path: 'userManagement',
        component: _import('userManagement/index'),
        name: 'userManagement',
        meta: {
          title: '客户管理',
          icon: 'userManagement'
        }
      },
      {
        path: 'userManagement/salesperson',
        component: _import('userManagement/salesperson'),
        name: 'salesperson',
        meta: {
          title: '销售人员',
          icon: 'userManagement'
        }
      }
    ]
  },
  //用户管理
  {
    path: '/',
    component: Layout,
    name: 'roleManager1',
    children: [
      {
        path: 'roleManager',
        component: _import('roleManager/index'),
        name: 'roleManager',
        meta: {
          title: '权限管理',
          icon: 'userManagement'
        }
      }
    ]
  },
  //产品中心
  {
    path: '/productCenter',
    component: Layout,
    redirect: 'noredirect',
    name: 'productCenter',
    meta: {
      title: '产品中心',
      icon: 'productSet'
    },
    children: [
      {
        path: 'commodityCenter',
        component: _import('productCenter/commodityCenter'),
        name: 'commodityCenter',
        meta: { title: '商品中心' }
      },
      {
        path: 'commodityShow',
        component: _import('productCenter/commodityShow'),
        name: 'commodityShow',
        meta: { title: '租赁中心' }
      },
      {
        path: 'productSet',
        component: _import('productCenter/productSet'),
        name: 'productSet',
        meta: { title: '商品管理' }
      },
      {
        path: 'deliveryAddress',
        component: _import('productCenter/deliveryAddress'),
        name: 'deliveryAddress',
        meta: { title: '收货地址' }
      },
      {
        path: 'profitSharing',
        component: _import('productCenter/profitSharing'),
        name: 'profitSharing',
        meta: { title: '分润管理' }
      },
      {
        path: 'profitConfig3',
        component: _import('productCenter/profitConfig3'),
        name: 'profitConfig3',
        meta: { title: '分润配置3' }
      }
    ]
  },
  //收益中心
  {
    path: '/revenueCenter',
    component: Layout,
    name: 'revenueCenter',
    redirect: 'noredirect',
    meta: {
      title: '收益中心',
      icon: 'revenueCenter'
    },
    children: [
      {
        path: 'billCenter',
        component: _import('revenueCenter/billCenter'),
        name: 'billCenter',
        meta: {
          title: '账单中心'
        }
      },
      {
        path: 'profitCenter',
        component: _import('revenueCenter/profitCenter'),
        name: 'profitCenter',
        meta: {
          title: '分润中心'
        }
      },
      {
        path: 'salesCenter',
        component: _import('revenueCenter/salesCenter'),
        name: 'salesCenter',
        meta: {
          title: '销量明细'
        }
      },
      {
        path: 'companyRevenue',
        component: _import('revenueCenter/companyRevenue'),
        name: 'companyRevenue',
        meta: {
          title: '招商分成'
        }
      }
    ]
  },
  //订单中心
  {
    path: '/',
    component: Layout,
    name: 'orderCenter1',
    redirect: 'noredirect',
    meta: {
      title: '订单中心',
      icon: 'orderCenter'
    },
    children: [
      {
        path: 'orderCenter',
        component: _import('orderCenter/index'),
        name: 'orderCenter',
        meta: {
          title: '订单记录',
          icon: 'orderCenter'
        }
      }
    ]
  },
  //消息中心
  {
    path: '/',
    component: Layout,
    name: 'messageCenter1',
    redirect: 'noredirect',
    meta: {
      title: '消息中心',
      icon: 'messageCenter'
    },
    children: [
      {
        path: 'messageCenter',
        component: _import('messageCenter/index'),
        name: 'messageCenter',
        meta: {
          title: '消息中心',
          icon: 'messageCenter'
        }
      }
    ]
  },
  //公司账号管理
  {
    path: '/',
    component: Layout,
    name: 'accountCenter1',
    redirect: 'noredirect',
    meta: {
      title: '公司账号管理',
      icon: 'userManagement'
    },
    children: [
      {
        path: 'accountCenter',
        component: _import('accountCenter/index'),
        name: 'accountCenter',
        meta: {
          title: '公司账号管理',
          icon: 'userManagement'
        }
      },
      {
        path: 'userManagementForBrand',
        component: _import('accountCenter/userManagementForBrand'),
        name: 'userManagementForBrand',
        meta: {
          title: '用户管理',
          icon: 'userManagement'
        }
      },
      {
        path: 'InstallerManagement',
        component: _import('accountCenter/Installer'),
        name: 'InstallerManagement',
        meta: {
          title: '安装师傅管理',
          icon: 'userManagement'
        }
      },
      {
        path: 'staffManagement',
        component: _import('accountCenter/staff'),
        name: 'staffManagement',
        meta: {
          title: '公司账号管理',
          icon: 'userManagement'
        }
      }
    ]
  },
  // 工厂
  {
    path: '/factory',
    component: Layout,
    name: 'factory',
    children: [
      {
        path: 'deviceMng',
        component: _import('factory/deviceMng'),
        name: 'deviceMng',
        meta: {
          title: '所有设备',
          icon: 'userManagement'
        }
      },
      {
        path: 'waterPurifierMng',
        component: _import('factory/waterPurifierMng'),
        name: 'waterPurifierMng',
        meta: {
          title: '商用净水器',
          icon: 'userManagement'
        }
      },
      {
        path: 'homeWaterPurifierMng',
        component: _import('factory/homeWaterPurifierMng'),
        name: 'homeWaterPurifierMng',
        meta: {
          title: '家用净水器',
          icon: 'userManagement'
        }
      },
      {
        path: 'teaTableMng',
        component: _import('factory/teaTableMng'),
        name: 'teaTableMng',
        meta: {
          title: '茶台伴侣',
          icon: 'userManagement'
        }
      },
      {
        path: 'desktopWaterPurifierMng',
        component: _import('factory/desktopWaterPurifierMng'),
        name: 'desktopWaterPurifierMng',
        meta: {
          title: '台式机',
          icon: 'userManagement'
        }
      }
    ]
  },
  //跨品牌商
  {
    path: '/crossBrandShare',
    component: Layout,
    name: 'crossBrandShare',
    children: [
      {
        path: 'deviceMng',
        component: _import('crossBrandShare/deviceMng'),
        name: 'deviceMng',
        meta: {
          title: '所有设备',
          icon: 'userManagement'
        }
      },
      {
        path: 'waterPurifierDetail',
        component: _import('crossBrandShare/waterPurifierDetail'),
        name: 'waterPurifierDetail',
        meta: { title: '净水器详情', hidden: true }
      }
    ]
  },
  {
    path: '/approvalManagement',
    component: Layout,
    redirect: 'noredirect',
    name: 'approvalManagement',
    meta: {
      title: '审批管理',
      icon: 'deviceManagement'
    },
    children: [
      {
        path: 'forMe',
        component: _import('approvalManagement/forMe'),
        name: 'forMe',
        meta: { title: '我的审批', icon: 'deviceManagement' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]
